import { v5 as $ } from "uuid";
import { A as b, m as C } from "./Logger-b1967205.mjs";
import { u as F } from "./ConfigService-a05d127e.mjs";
var a = /* @__PURE__ */ ((e) => (e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.DELETE = "DELETE", e.PATCH = "PATCH", e))(a || {});
const J = (e = 16) => parseInt(
  Math.ceil(Math.random() * Date.now()).toPrecision(e).toString().replace(".", "")
), O = (e) => Array(e).fill(0).map(() => Math.floor(Math.random() * 16).toString(16)).join(""), m = {
  error: {
    E001: "URL not valid",
    E002: "Invalid Parameters",
    E003: "Body not provided!",
    E004: "Something went wrong",
    E005: "Request already in process",
    E006: "Bad Request",
    E007: "Request Timeout"
  },
  info: {
    I001: "API Cache initialized!!",
    I002: "Cached API requests:"
  },
  labels: {
    L001: "API Res",
    L002: "Response With Error"
  }
};
var W = Object.defineProperty, _ = (e, t, r) => t in e ? W(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, w = (e, t, r) => (_(e, typeof t != "symbol" ? t + "" : t, r), r);
const M = class P {
  constructor() {
    w(this, "cache", /* @__PURE__ */ new Map()), w(this, "loggerServiceInstance", b.getInstance()), this.loggerServiceInstance.info(m.info.I001);
  }
  static getInstance() {
    return P.instance || (P.instance = new P()), P.instance;
  }
  /**
   * set url in an array
   * @param url string
   */
  pushUrl(t) {
    this.cache.set(t, !0);
  }
  /**
   * check weather url present in an array
   * @param url string
   * @returns booelan true/false
   */
  hasUrl(t) {
    return this.cache.has(t);
  }
  /**
   * remove items from array
   * @param url string
   */
  remove(t) {
    this.cache.delete(t);
  }
  /**
   * check cached URLs
   * DEBUGGING puposes
   */
  entries() {
    this.loggerServiceInstance.info(m.info.I002, this.cache);
  }
};
w(M, "instance");
let z = M;
const d = {
  LoggerServiceAlreadyLoaded: "Logger Service already loaded, using existing version",
  RequestStart: "API Request Start",
  RequestUrlAlreadyRequested: (e) => `%c ${e} is already requested`,
  RequestOptions: (e) => `%c Request Options: ${JSON.stringify(e, null, 2)}`,
  RequestComplete: "API Request Complete.",
  RequestError: "API Request error occurred",
  RequestInterceptorExecuted: "API Request Request Interceptors executed",
  RequestIdempotencyAdded: "API Request Idempotency key added.",
  ResponseConvertedToJSON: "API Request Response converted to JSON.",
  ResponseInterceptorExecuted: "API Request Response Interceptors executed",
  DefaultContentType: "Defaul content type added",
  RequestUrlCached: "Request url pushed to cacheInstance",
  RequestBodyParsed: "Request body parsed",
  DefaultErrorHandler: "Inside default error handlers",
  ReqeuestWithTraceId: "Request with traceId",
  SplunkSuccessfulLog: (e) => `%c Successfully Log sent to Splunk: ${e}`,
  SplunkFailedLog: (e) => `Failed Log Request with Status code: ${e}`,
  SplunkErrorLog: (e) => `Error while sending log to Splunk: ${e}`
}, K = function(e, t) {
  let r = {};
  if (e)
    if (e.ApiConfigService)
      ({ ApiConfigService: r } = e);
    else
      return e.ApiConfigService = r, t(r);
  return r;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let t = "", r = {};
    const o = () => t, n = (h) => {
      t = h;
    }, u = () => r, i = (h, l) => {
      r[h] = l;
    }, p = (h) => {
      r = h;
    };
    return e.getBaseUrl = o, e.setBaseUrl = n, e.getTuples = u, e.addTuple = i, e.setTuples = p, e;
  }
), S = {
  contentType: "Content-Type"
};
var Q = Object.defineProperty, Y = (e, t, r) => t in e ? Q(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Z = (e, t, r) => (Y(e, typeof t != "symbol" ? t + "" : t, r), r);
let L = class extends Error {
  constructor(t, r) {
    super(), Z(this, "responseBody"), this.message = t, this.responseBodyArg = r, this.responseBody = r;
  }
};
var ee = Object.defineProperty, te = (e, t, r) => t in e ? ee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, U = (e, t, r) => (te(e, typeof t != "symbol" ? t + "" : t, r), r);
let re = class {
  /**
   * check if any errros are overriden from FE
   * @param options override or extend errors
   *
   */
  constructor(t = {}) {
    U(this, "overrideOptions", {}), U(this, "loggerServiceInstance", b.getInstance()), this.overrideOptions = t;
  }
  /**
   * check if any errros are overriden from FE
   * @param apiRes response of the api
   */
  async handlerErrors(t) {
    this.loggerServiceInstance.debug(m.labels.L001, t), this.overrideOptions[t.status] ? this.overrideOptions[t.status](t) : this.overrideOptions.default ? this.overrideOptions.default(t) : await this.handleDefaultErrors(t);
  }
  /**
   * handling deafult errors
   * @param apiRes response of the api
   */
  async handleDefaultErrors(t) {
    this.loggerServiceInstance.debug(d.DefaultErrorHandler);
    const r = t.headers.get(S.contentType);
    let o = {};
    switch (r != null && r.includes("json") && (o = await t.json(), this.loggerServiceInstance.debug(d.ResponseConvertedToJSON)), t.status) {
      case 400:
        throw new L(m.error.E006, o);
      default:
        throw new L(m.error.E004, o);
    }
  }
};
const oe = (e) => new Promise((t) => {
  setTimeout(() => t(), e);
}), ne = (e, t) => {
  const r = [`curl -X ${t.method || "GET"}`];
  if (t.headers)
    for (const [o, n] of Object.entries(t.headers))
      r.push(`-H "${o}: ${n}"`);
  if (t.body) {
    const o = typeof t.body == "object" ? JSON.stringify(t.body) : t.body;
    r.push(`--data '${o}'`);
  }
  return r.push(`"${e}"`), r.join(" ");
}, X = async (e, t) => {
  var r;
  const { retries: o, params: n, errorHandlers: u, delay: i = 0, retryOnStatus: p, customRetryFunction: h, ...l } = t, y = b.getInstance();
  if (!e)
    throw y.error(m.error.E001), new Error(m.error.E001);
  let T = e;
  n && (T = `${e}?${new URLSearchParams(n)}`);
  try {
    (r = process == null ? void 0 : process.env) != null && r.REQUEST_CURL_LOG && y.log(`Request curl: ${ne(T, t)}`);
    const g = await fetch(T, l);
    return g.ok ? g : h ? h(e, t, g) : o && p != null && p.includes(g.status) ? (await oe(i), X(e, {
      ...t,
      retries: o && o - 1
    })) : (y.error(m.labels.L002, T, t, g), await new re(u).handlerErrors(g), g);
  } catch (g) {
    throw y.error(m.error.E004, "Error caught", g, T, t), g instanceof L ? g : new Error(m.error.E004);
  }
}, se = J();
let q;
const f = (e, t) => new Promise((r, o) => {
  const n = b.getInstance();
  n.debug("Step-1", d.RequestStart), q = new AbortController();
  const u = F.getConfigs(), i = K.getBaseUrl(), p = z.getInstance(), h = (t == null ? void 0 : t.customCache) || !1, { url: l, timeout: y = u.NEXT_PUBLIC_REQUEST_TIMEOUT || 6e3 } = e, T = ae(e, t);
  if (h)
    if (p.hasUrl(l)) {
      n.debug("Step-6", d.RequestUrlAlreadyRequested(l), "color: red"), r({ res: m.error.E005 });
      return;
    } else
      p.pushUrl(l), n.debug("Step-6", d.RequestUrlCached);
  const g = setTimeout(() => {
    n.error({
      message: m.error.E007,
      status: 504
    }), q.abort(), o({ message: m.error.E007, status: 504 });
  }, y);
  X(l.indexOf("http://") === -1 && l.indexOf("https://") === -1 ? `${i}${l}` : l, T).then(async (E) => {
    const V = await ue(E, t);
    n.debug("Step-9", d.RequestComplete), r(V);
  }).catch((E) => {
    n.error(d.RequestError, E), o(E);
  }).finally(() => {
    clearTimeout(g), h && p.remove(l);
  });
});
f.get = (e, t) => f({ ...e, method: a.GET }, t);
f.post = (e, t) => f({ ...e, method: a.POST }, t);
f.put = (e, t) => f({ ...e, method: a.PUT }, t);
f.delete = (e, t) => f({ ...e, method: a.DELETE }, t);
f.patch = (e, t) => f({ ...e, method: a.PATCH }, t);
const N = (e) => e || {}, ce = (e, t) => {
  const r = b.getInstance();
  let o = { ...e };
  if (!(t != null && t.byPassInterceptors) && t != null && t.interceptors) {
    for (const n of t.interceptors)
      o = n == null ? void 0 : n.requestInterceptor(o);
    r.debug("Step-3", d.RequestInterceptorExecuted);
  }
  return o;
};
function ae(e, t) {
  var r;
  const o = b.getInstance();
  let n = {};
  const { signal: u } = q;
  t != null && t.skipDefaultContentType || (Object.assign(n, {
    [S.contentType]: "application/json"
  }), o.debug("Step-2", d.DefaultContentType));
  let i = e;
  const p = K.getTuples();
  n = {
    ...n,
    ...N(p)
  };
  const h = F.getConfigs();
  if ((typeof window > "u" || !window) && !h.NEXT_PUBLIC_OTEL_TRACING) {
    const l = $(i.url + J(), $.URL), y = `00-${O(32)}-${O(16)}-01`;
    n = {
      ...n,
      "X-Request-Id": l,
      //# traceparent value : {version}-{trace_id}-{span_id}-{trace_flags}
      traceparent: y
    }, o.debug(
      d.ReqeuestWithTraceId,
      `reqId: ${l}`,
      `traceparent: ${y}`,
      e
    );
  }
  if (i.headers = {
    ...n,
    ...N(i.headers)
  }, i = ce(i, t), i.body && ((r = i.headers) == null ? void 0 : r[S.contentType]) === "application/json" && (i.body = JSON.stringify(i.body), o.debug("Step-4", d.RequestBodyParsed)), t != null && t.log && o.log(d.RequestOptions(i), "color: blue"), i.method === a.POST && (i.body || o.warn(m.error.E003)), (i.method === a.POST || i.method === a.PATCH || i.method === a.PUT) && !(t != null && t.skipIdempotency)) {
    if (i.headers = { ...i.headers }, t != null && t.customKeyGenerator) {
      const l = t.customKeyGenerator();
      i.headers["X-Idempotency-Key"] = l;
    } else {
      const l = $(i.url + se, $.URL);
      i.headers["X-Idempotency-Key"] = l;
    }
    o.debug("Step-5", d.RequestIdempotencyAdded);
  }
  return {
    ...i,
    customRetryFunction: i.customRetryFunction,
    signal: u
  };
}
async function ue(e, t) {
  var r;
  const o = b.getInstance();
  let n = e;
  try {
    const u = e.headers.get(S.contentType);
    if (u != null && u.includes("json") && (n = await e.json(), o.debug("Step-7", d.ResponseConvertedToJSON)), t && !t.byPassInterceptors && t.interceptors) {
      for (let i = t.interceptors.length - 1; i >= 0; i--)
        n = (r = t.interceptors[i]) == null ? void 0 : r.responseInterceptor(n);
      o.debug("Step-8", d.ResponseInterceptorExecuted);
    }
    return n;
  } catch (u) {
    throw o.error(u), u;
  }
}
function k(e) {
  return {
    url: `/comcontactas/${e}/contacts`,
    method: a.POST,
    retries: 0
  };
}
function R(e) {
  return {
    url: `/comcontactas/${e}/contacts`,
    method: a.GET,
    retries: 0
  };
}
function ie(e, t) {
  return {
    url: `/comcontactas/${e}/contacts/${t}`,
    method: a.GET,
    retries: 0
  };
}
function D(e, t) {
  return {
    url: `/comcontactas/${e}/contacts/${t}`,
    method: a.PUT,
    retries: 0
  };
}
function le(e) {
  return {
    url: `/comprofileas/${e}/checkUser`,
    method: a.GET,
    retries: 0
  };
}
function de(e) {
  return {
    url: `/comaccountas/${e}/checkUser`,
    method: a.GET,
    retries: 0
  };
}
function j(e) {
  return {
    url: `/comprofileas/${e}/profiles`,
    method: a.GET,
    retries: 0
  };
}
function pe(e) {
  return {
    url: `/comprofileas/${e}/government-records`,
    method: a.GET,
    retries: 0
  };
}
function me(e) {
  return {
    url: `/comprofileas/${e}/government-records`,
    method: a.POST,
    retries: 0
  };
}
function he(e) {
  return {
    url: `/comprofileas/${e}/government-records`,
    method: a.PATCH,
    retries: 0
  };
}
function I(e) {
  return {
    url: `/comregistrationas/${e}/sponsors`,
    method: a.GET,
    retries: 0,
    timeout: 6e4
  };
}
function G(e) {
  return {
    url: `/comregistrationas/${e}/registrations`,
    method: a.GET,
    retries: 0
  };
}
function ge(e) {
  return {
    url: `/comregistrationas/${e}/registrations`,
    method: a.POST,
    retries: 0
  };
}
function fe(e) {
  return {
    url: `/comregistrationas/${e}/registrations`,
    method: a.PATCH,
    retries: 0,
    timeout: 6e4
  };
}
function ye(e, t) {
  return {
    url: `/comregistrationas/${e}/registrations/${t}/submit`,
    method: a.POST,
    retries: 3,
    timeout: 6e4
  };
}
function A(e) {
  return {
    url: `/comcontactas/${e}/contact-search`,
    method: a.GET,
    retries: 0
  };
}
function Te(e) {
  return {
    url: `/comcontactas/${e}/daneCode`,
    method: a.GET,
    retries: 0
  };
}
function be(e, t) {
  return {
    url: `/comprofileas/${e}/profiles/${t}/challenges`,
    method: a.POST,
    retries: 0
  };
}
function $e(e, t) {
  return {
    url: `/comaccountas/${e}/accounts/${t}/challenges`,
    method: a.POST,
    retries: 0
  };
}
function Pe(e, t) {
  return {
    url: `/comaccountas/${e}/accounts/${t}/autoRenew`,
    method: a.GET,
    retries: 0
  };
}
function Ee(e, t) {
  return {
    url: `/comaccountas/${e}/accounts/${t}/autoRenew`,
    method: a.DELETE,
    retries: 0
  };
}
function Ie(e) {
  return {
    url: `/comprofileas/${e}/profiles`,
    method: a.PATCH,
    retries: 0
  };
}
function Se(e) {
  return {
    url: `/comblocksprivilegesas/${e}/tasks`,
    method: a.GET,
    retries: 0,
    timeout: 6e4
  };
}
function Re(e, t) {
  return {
    url: `/comregistrationas/${e}/registrations/${t}/challenges`,
    method: a.POST,
    retries: 0,
    timeout: 6e4
  };
}
function Ae(e, t) {
  return {
    url: `/comcontactas/${e}/contacts/${t}`,
    method: a.DELETE,
    retries: 0
  };
}
function B(e, t) {
  return {
    url: `/comcontactas/${e}/${t}`,
    method: a.GET,
    retries: 0
  };
}
function v(e) {
  return {
    url: `/comcontractas/${e}/contracts`,
    method: a.GET,
    retries: 0
  };
}
function ve(e) {
  return {
    url: `/comcontractas/${e}/contracts`,
    method: a.PATCH,
    retries: 0
  };
}
function H(e) {
  return {
    url: `/comdocumentas/${e}/documents`,
    method: a.GET,
    retries: 0
  };
}
function Ce(e) {
  return {
    url: `/comdocumentas/${e}/documents`,
    method: a.POST,
    retries: 0
  };
}
function x(e) {
  return {
    url: `/comaccountas/${e}/accounts`,
    method: a.GET,
    retries: 0
  };
}
function we(e) {
  return {
    url: `/comaccountsearchas/${e}/search`,
    method: a.GET,
    retries: 0
  };
}
function Le(e) {
  return {
    url: `/comprofilesubas/${e}/publications`,
    method: a.GET,
    retries: 0
  };
}
function qe(e) {
  return {
    url: `/comprofilesubas/${e}/publications`,
    method: a.PATCH,
    retries: 0
  };
}
function Oe(e) {
  return {
    url: `/comaccountas/${e}/phones`,
    method: a.GET,
    retries: 0
  };
}
function Ue(e) {
  return {
    url: `/comaccountas/${e}/emails`,
    method: a.GET,
    retries: 0
  };
}
function Ne(e) {
  return {
    url: `/comaccountas/${e}/phones`,
    method: a.POST,
    retries: 0
  };
}
function ke(e) {
  return {
    url: `/comaccountas/${e}/emails`,
    method: a.POST,
    retries: 0
  };
}
function De(e, t) {
  return {
    url: `/comaccountas/${e}/phones/${t}`,
    method: a.PATCH,
    retries: 0
  };
}
function je(e, t) {
  return {
    url: `/comaccountas/${e}/emails/${t}`,
    method: a.PATCH,
    retries: 0
  };
}
function Ge(e, t) {
  return {
    url: `/comaccountas/${e}/phones/${t}`,
    method: a.DELETE,
    retries: 0
  };
}
function Be(e, t) {
  return {
    url: `/comaccountas/${e}/emails/${t}`,
    method: a.DELETE,
    retries: 0
  };
}
const s = "v1", Ke = {
  createShippingDetails({ payload: e }, t) {
    const r = k(s);
    return e ? (r.body = e, c(r, t, !0)) : Promise.reject("Please check arguments");
  },
  getShippingAddressList({ contactType: e, ownerId: t, accountNumber: r }, o) {
    const n = R(s);
    return n.params = {
      contactType: e,
      ...t && { ownerId: t },
      ...r && { accountNumber: r }
    }, c(n, o);
  },
  putShippingAddressList({ payload: e, contactId: t }, r) {
    const o = D(s, t);
    return !t || !e ? Promise.reject("Please check arguments") : (o.body = e, c(o, r, !0));
  },
  postCheckUser({ username: e }, t) {
    const r = le(s);
    return e ? (r.params = {
      username: e
    }, c(r, t)) : Promise.reject("Please check arguments");
  },
  checkAccountUserExists({ username: e }) {
    const t = de(s);
    return e ? (t.params = {
      username: e
    }, c(t)) : Promise.reject("Please check arguments");
  },
  getProfiles(e) {
    const t = j(s);
    return c(t, e);
  },
  getDownlineAddressList({ contactType: e, ownerId: t, accountNumber: r }, o) {
    const n = R(s);
    return n.params = {
      contactType: e,
      ownerId: t,
      accountNumber: r
    }, c(n, o);
  },
  getSponsorByAccountNumber({ sponsorInputValue: e, accountType: t }, r) {
    const o = I(s);
    return !e || !t ? Promise.reject("Please check arguments") : (o.params = {
      regAccountType: t,
      accountNumber: e
    }, c(o, r));
  },
  getLeadsListByPostalCode({ sponsorInputValue: e, accountType: t }, r) {
    const o = I(s);
    return !e || !t ? Promise.reject("Please check arguments") : (o.params = {
      regAccountType: t,
      postalCd: e
    }, c(o, r));
  },
  getLeadsListWithoutPostalCode({ accountType: e, state: t, city: r }, o) {
    const n = I(s);
    if (!e)
      return Promise.reject("Please check arguments");
    const u = new URLSearchParams();
    return u.append("regAccountType", e), t && u.append("state", t), r && u.append("city", r), n.params = u, c(n, o);
  },
  getInternationalSponsor({
    sponsorInputValue: e,
    internationalSponsorAccountNumber: t,
    internationalSponsorCountryCode: r,
    accountType: o
  }, n) {
    const u = I(s);
    return !e || !o || !r || !t ? Promise.reject("Please check arguments") : (u.params = {
      regAccountType: o,
      accountNumber: e
    }, t && r && (u.params.internationalSponsorAccountNumber = t, u.params.internationalSponsorCountryCode = r), c(u, n));
  },
  createRegistrationId(e, t, r) {
    const o = ge(s);
    return o.body = e, c(o, t, r);
  },
  getRegistration({ accountNumber: e, status: t, registrationFlow: r }, o) {
    const n = G(s), u = new URLSearchParams();
    return e && u.append("accountNumber", e.toString()), t && u.append("status", t), r && u.append("registrationFlow", r), n.params = u, c(n, o);
  },
  getRegistrationDetailsById(e, t, r) {
    const o = G(s);
    return o.url += `/${e}`, r && (o.params = {
      projection: r
    }), c(o, t);
  },
  async patchRegistration(e, t, r, o) {
    const n = fe(s);
    return n.url += `/${t}`, r && (n.params = {
      stepName: r
    }), n.body = e, await c(n, o);
  },
  postSubmitRegistration(e, t, r) {
    const o = ye(s, t);
    return t ? (o.body = e, c(o, r)) : Promise.reject("Please check arguments");
  },
  contactSearch(e, t) {
    const r = A(s);
    return r.params = {
      query: e
    }, c(r, t);
  },
  contactSearchContainer(e, t) {
    const r = A(s);
    return r.params = {
      containerId: e
    }, c(r, t);
  },
  contactSearchMatchId(e, t) {
    const r = A(s);
    return r.url += `/${e}`, c(r, t);
  },
  getDaneCodeByStateCity(e, t, r) {
    const o = Te(s);
    return o.params = {
      state: e,
      city: t
    }, c(o, r);
  },
  getProfilesById(e, t) {
    const r = j(s);
    return r.url += `/${e}`, c(r, t);
  },
  patchProfilesById({ payload: e, profileId: t }, r) {
    const o = Ie(s);
    return o.url += `/${t}`, o.body = e, c(o, r);
  },
  getProfileAddress({ ownerId: e, isDefault: t }, r) {
    const o = R(s);
    return o.params = {
      ownerId: e,
      isDefault: t ? "true" : "false"
    }, c(o, r);
  },
  postProfileAddress({ payload: e }, t) {
    const r = k(s);
    return r.body = e, c(r, t, !0);
  },
  putProfileAddress({ payload: e, contactId: t }, r) {
    const o = D(s, t);
    return !t || !e ? Promise.reject("Please check arguments") : (o.body = e, c(o, r, !0));
  },
  getAddressByContactId(e, t) {
    const r = ie(s, e);
    return e ? c(r, t, !0) : Promise.reject("Please check arguments");
  },
  postProfileChallange({ payload: e, profileId: t }, r) {
    const o = be(s, t);
    return !t || !e ? Promise.reject("Please check arguments") : (o.body = e, c(o, r, !0));
  },
  postAccountChallenge({ payload: e, accountNum: t }, r) {
    const o = $e(s, t);
    return !t || !e ? Promise.reject("Please check arguments") : (o.body = e, c(o, r, !0));
  },
  getTaskList(e, t, r, o) {
    const n = Se(s);
    return n.params = {
      accountNumber: e
    }, t && (n.params.type = t), r && (n.params.status = r), c(n, o);
  },
  postRegistrationChallenge({ payload: e, registrationId: t }, r) {
    const o = Re(s, t);
    return !t || !e ? Promise.reject("Please check arguments") : (o.body = e, c(o, r, !0));
  },
  deleteShippingAddressList(e, t) {
    const r = Ae(s, e);
    return e ? c(r, t) : Promise.reject("Please check arguments");
  },
  getContractList(e, t) {
    const r = v(s);
    return r.params = {
      accountNumber: e
    }, c(r, t);
  },
  getContractDetailList({ contractId: e, contractType: t, accountSubTypeCd: r, seqNo: o, locale: n, busEntityNum: u }, i) {
    const p = v(s);
    return p.url += `/${e}`, p.params = {
      accountSubTypeCd: r,
      contractType: t,
      seqNo: String(o),
      ...n && { language: n },
      ...u && { busEntityNum: u }
    }, c(p, i);
  },
  getContractPdf({ contractId: e, contractType: t, accountSubTypeCd: r, seqNo: o, busEntityNum: n }, u) {
    const i = v(s);
    return i.url += `/${e}/pdf`, i.params = {
      accountSubTypeCd: r,
      contractType: t,
      seqNo: String(o),
      ...n && { busEntityNum: n }
    }, c(i, u);
  },
  patchContract({ contractId: e, contract: t }, r) {
    const o = ve(s);
    return o.url += `/${e}`, o.body = t, c(o, r);
  },
  getDocumentList(e, t, r, o) {
    const n = H(s);
    return n.params = {
      profileId: t,
      accountNumber: e,
      ...r && { approvalStatus: r }
    }, c(n, o);
  },
  getDocumentById(e, t) {
    const r = H(s);
    return r.url += `/${e}`, c(r, t);
  },
  postDocument(e, t) {
    const r = Ce(s);
    return e ? f.post(
      {
        ...r,
        body: e,
        headers: r.headers,
        ...(t == null ? void 0 : t.baseURL) && { baseURL: t.baseURL }
      },
      {
        skipDefaultContentType: !0
      }
    ) : Promise.reject("Please check arguments");
  },
  getAddressRegionData(e, t, r) {
    const o = B(s, e);
    return o.params = {
      language: t
    }, c(o, r);
  },
  getAddressRegionSearch(e, t, r) {
    const o = B(s, e);
    return o.params = {
      ...t
    }, c(o, r);
  },
  getAccountByNum(e, t, r) {
    const o = x(s);
    return o.url += `/${e}/mappings`, t !== void 0 && (o.params = {
      isPrimary: t ? "true" : "false"
    }), c(o, r);
  },
  getAccountInformation(e, t) {
    const r = x(s);
    return r.url += `/${e}`, c(r, t);
  },
  getAccountAutoRenewal(e, t) {
    const r = Pe(s, e);
    return c(r, t);
  },
  deleteAccountAutoRenewal(e, t) {
    const r = Ee(s, e);
    return c(r, t);
  },
  getPublication(e, t, r) {
    const o = Le(s);
    return o.params = {
      accountNumber: e,
      profileId: t
    }, c(o, r);
  },
  patchPublication(e, t, r, o) {
    const n = qe(s);
    return n.params = {
      accountNumber: e,
      profileId: t
    }, n.body = r, c(n, o);
  },
  getAccountPhones(e, t, r = !0, o = !1, n) {
    try {
      const u = Oe(s);
      return u.params = {
        accountNumber: e,
        profileId: t,
        ...r && { isDefault: "true" },
        // For alternative phone numbers, isDefault is not required
        isDeleted: String(o)
      }, c(u, n);
    } catch (u) {
      return C.error(u), Promise.resolve({ phoneList: [] });
    }
  },
  getAccountEmails(e, t, r = !0, o = !1, n) {
    try {
      const u = Ue(s);
      return u.params = {
        accountNumber: e,
        profileId: t,
        isDefault: String(r),
        isDeleted: String(o)
      }, c(u, n);
    } catch (u) {
      return C.error(u), Promise.resolve({ emailList: [] });
    }
  },
  postAccountPhone(e, t) {
    const r = Ne(s);
    return r.body = e, c(r, t);
  },
  postAccountEmail(e, t) {
    const r = ke(s);
    return r.body = e, c(r, t);
  },
  patchAccountPhone(e, t, r) {
    const o = De(s, e);
    return o.body = t, c(o, r);
  },
  patchAccountEmail(e, t, r) {
    const o = je(s, e);
    return o.body = t, c(o, r);
  },
  deleteAccountPhone(e, t) {
    const r = Ge(s, e);
    return c(r, t);
  },
  deleteAccountEmail(e, t) {
    const r = Be(s, e);
    return c(r, t);
  },
  getAccountDetails(e, t) {
    const r = we(s);
    return r.params = e.params, c(r, t);
  },
  getGovernmentRecords(e, t) {
    const r = pe(s);
    return r.params = {
      profileId: e
    }, c(r, t);
  },
  postGovernmentRecords(e, t) {
    const r = me(s);
    return r.body = e, c(r, t);
  },
  patchGovernmentRecords(e, t, r) {
    const o = he(s);
    return o.url = `${o.url}/${e}`, o.body = t, c(o, r);
  }
};
async function c(e, t, r) {
  try {
    t != null && t.headers && (e.headers = t == null ? void 0 : t.headers), t != null && t.baseURL && (e.url = `${t.baseURL}${e.url}`);
    const o = await f(e, r ? {
      skipIdempotency: !1,
      customCache: !0,
      customKeyGenerator: () => $(`${Date.now()}`, $.URL)
    } : {});
    return Promise.resolve(o);
  } catch (o) {
    throw C.error(o), o;
  }
}
export {
  K as i,
  Ke as n
};
//# sourceMappingURL=profileApi-b96df38d.mjs.map
